import { Component, OnInit, Renderer2, ChangeDetectorRef, Input } from '@angular/core';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BillingCodeRatesBus } from '../../../../shared/models/BillingCodeRatesBus';
import { SaveMode } from '../../../../shared/enums/SaveMode';
import { v_InventoryBus } from '../../../../shared/models/v_InventoryBus';
import { InventoryService } from '../../../../shared/services/inventory.service';
import { CRUDActions } from '../../../../shared/enums/CRUDActions';
import { ConfirmOutput } from '../../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../../shared/enums/CPDialogResult';
import { UnionJobRoleXrefBus } from '../../../../shared/models/UnionJobRoleXrefBus';
import { EmployeeService } from '../../../../shared/services/employee.service';
import { EmployeeReference } from '../../../../shared/models/employeeReference';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'union-xref',
    templateUrl: './union-xref.component.html',
    styleUrls: ['./union-xref.component.scss']
})
export class UnionXrefsComponent extends BaseGridEditLineComponent<UnionJobRoleXrefBus, null, EmployeeService> {
    @Input() employeeReferenceData: EmployeeReference;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: EmployeeService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "UnionJobRoleXrefBus";
        this.appCode = "UnionJobRoleXref";
        this.saveMode = SaveMode.all;
        this.inventorySvcField = "number";
        this.disableCpSearchDialog();
    }
    override createForm() {
        this.editForm = new UntypedFormGroup({
            'unionJobRoleXrefId': new UntypedFormControl(),
            'jobRoleId': new UntypedFormControl(),
            'unionId': new UntypedFormControl(),
            'rate': new UntypedFormControl(),
            'overheadRate': new UntypedFormControl(),
            'shiftRate': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),        });

    }
    override setForm() {
        this.editForm.patchValue({

            unionJobRoleXrefId: this.selectedData.unionJobRoleXrefId,
            //billingCode:this.referenceData.getBillingCodeDesc(this.selectedData.billingCodeId),
            unionId: this._parentId,
            jobRoleId: this.selectedData.jobRoleId,
            rate: this.selectedData.rate,
            overheadRate: this.selectedData.rate,
            shiftRate: this.selectedData.rate,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,

        });
    }

    confirmCustom(data: ConfirmOutput) {
        if (data.code === 'DUPBILLINGCODE') {
            if (data.dialogResult === CPDialogResult.ok) {
                this.addHandler();

            } else
            {
                this.cancelHandler();
            }
        }
        else { super.confirmCustom(data);}
    }
}
